<template>
  <div
    class="w-full bg-zt-white rounded-zt-md p-6"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center" v-if="isComponentVisible">
      <div
        class="mb-4 flex justify-center h-full"
        :class="[boxLogin.sizeLogo === 'full' ? 'w-full' : 'w-56']"
      >
        <img class="format-img" :src="boxLogin.logoUrl" alt="" />
      </div>
      <div
        v-if="!isResetPassSuccess"
        class="text-center w-11/12"
        :style="[boxLogin.styles.form.textColor]"
      >
        <h1 class="text-zt-lg mb-3 font-bold">
          {{ $t('message.resetPassComponent.title') }}
        </h1>
        <p>{{ $t('message.resetPassComponent.subtitle') }}</p>
      </div>
      <div class="w-full" v-if="resetPassErrors.showMessage">
        <zt-alert
          :text="resetPassErrors.message"
          color="danger"
          :duration="resetPassErrors.MAX_DURATION_ALERT"
          @afterClosed="resetPassErrors.showMessage = false"
        />
      </div>
      <div class="mt-4 w-full">
        <ValidationObserver v-slot="{ invalid }">

          <zt-auth-reset-pass-fields
            v-if="!isResetPassSuccess"
            v-model="resetPassFields"
            :password-policies="passPolicies"
            :first-login-custom-params-fields="boxLogin"
          />
          <zt-auth-reset-pass-success
            v-if="isResetPassSuccess"
            :first-login-custom-params-fields="boxLogin"
          />
          <div class="mb-4" v-if="!isResetPassSuccess">
            <zt-button
              class="w-full opacity-100"
              :style="[bgButtonColor(invalid)]"
              :disabled="invalid || disabledButton"
              @click="sendResetPassword"
              data-vs-button="auth-resetpass-btn-sendresetpass"
            >
              <span v-if="!isLoadingResetPass">
                {{ $t('message.loginComponent.forgetPassword.send') }}
              </span>
              <vue-loading
                v-if="isLoadingResetPass"
                background-color="rgba(0,0,0,0.0)"
                :active="isLoadingResetPass"
                color="#4F41A3"
                :width="30"
                :height="30"
                :is-full-page="false"
              />
            </zt-button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'
import { mapGetters } from 'vuex'
import Users from '@/apiClient/Users'
import ZtAuthResetPassFields from '@/modules/Auth/components/authResetPassFields'
import ZtAuthResetPassSuccess from '@/modules/Auth/components/authResetPassSuccess'
import Company from '@/apiClient/Company';

export default {
  name: 'ztResetPassword',
  components: {
    ZtAuthResetPassSuccess,
    ZtAuthResetPassFields
  },
  data() {
    return {
      passPolicies: {},
      company: '',
      objectLoginParams: {},
      isLoadingResetPass: false,
      disabledButton: false,
      resetPassFields: {
        password: '',
        rePassword: ''
      },
      resetPassErrors: {
        message: '',
        showMessage: false,
        MAX_DURATION_ALERT: 4
      },
      isResetPassSuccess: false,
      isComponentVisible: false,
      isInIframe: false
    }
  },
  mixins: [loginCustomParams],
  computed: {
    ...mapGetters({
      getLoginCustomParams: 'auth/getLoginCustomParams'
    }),
    bgButtonColor() {
      return invalid =>
        invalid
          ? { backgroundColor: '#E2E2E2' }
          : this.boxLogin.styles.form.buttons.bgColor
    }
  },
  methods: {
    async sendResetPassword() {
      this.isLoadingResetPass = true
      this.disabledButton = true
      try {
        await this.user.setNewPassword(
          this.$route.params.token,
          this.resetPassFields.password
        )
        this.isResetPassSuccess = true
        this.isLoadingResetPass = false
        this.disabledButton = false
      } catch (error) {
        this.handleErrors(error)
      }
    },
    handleErrors(error) {
      try {
        this.isLoadingResetPass = false
        this.disabledButton = false
        this.resetPassErrors.showMessage = true
        typeof error === 'string'
          ? (this.resetPassErrors.message = this.$t(
              `message.errorReference.${error}`
            ))
          : (this.resetPassErrors.message = this.$t(
              `message.errorReference.${error.response.data.code}`
            ))
      } catch (e) {
        this.isLoadingResetPass = false
        this.disabledButton = false
        this.$store.dispatch('clearState')
      }
    },
    async getPasswordPolicies(token) {
      await this.company
              .passwordPoliciesTk(token)
              .then(response => {
                this.passPolicies = response.data
              })
              .catch(error => {})
    },
  },
  mounted() {
    if (this.isInIframe) {
      setTimeout(() => {
        this.isComponentVisible = true;
      }, 1000);
    }
  },
  created() {
    this.isInIframe = window.self !== window.top;
    if (!this.isInIframe) {
      this.isComponentVisible = true;
    }
    this.company = new Company()
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
    this.user = new Users()
    this.getPasswordPolicies(this.$route.params.token);

  }
}
</script>

<style scoped lang="scss">
.format-img {
  height: 100%;
  max-width: 100%;
  vertical-align: middle;
  width: 100%;
  -ms-interpolation-mode: bicubic;
  display: inline-block;
}
::v-deep .zt-button {
  height: 3.25rem;
}

</style>

